import api from "../../api/index.js";

const state = {};

const getters = {};

const actions = {
  OrderList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/TransactionOrder/List",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  MOrderList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/TransactionOrder/MList",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  OrderProductList({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.get(
        "/TransactionOrder/OrderProductList",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  AddProductOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/TransactionOrder/AddProductOrder",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  AddCartProductOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/TransactionOrder/AddCartProductOrder",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  CancelOrder({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/TransactionOrder/CancelOrder",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  OrderSpinOff({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/TransactionOrder/OrderSpinOff",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  OrderFinish({ commit }, payload) {
    return new Promise((resolve, reject) => {
      api.post(
        "/TransactionOrder/OrderFinish",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });
  },
  OrderOtherFinish({ commit }, payload){
    return new Promise((resolve, reject) => {
      api.post(
        "/TransactionOrder/OrderOtherFinish",
        payload,
        res => {
          resolve(res);
        },
        err => {
          reject(err);
        }
      );
    });

  }
};

const mutations = {};

export default {
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/transactionOrder.js